<template>
  <div class="title">
    <div :class="['titleFont', { pointer: cursor }]" @click="$emit('navigation')">
      {{ title }}
    </div>
  </div>
</template>

<script>
export default {
  name: "myTitle",
  props: {
    title: {
      type: String,
      default: "标题",
    },
    cursor: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
};
</script>

<style scoped lang="scss">
.title {
  width: 100%;
  height: 45px;
  line-height: 36px;
  background: url("~@/assets/images/cTitle.png") no-repeat;
  background-size: 100% 100%;

  .titleFont {
    color: #fff;
    font-size: 22px;
    text-indent: 80px;
  }

  .pointer {
    cursor: pointer;
  }
}
</style>
